import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'now-wbsuche-lib-suchergebnis-empty-state',
  templateUrl: './suchergebnis-empty-state.component.html',
  styleUrls: ['./suchergebnis-empty-state.component.scss'],
  imports: [NgOptimizedImage]
})
export class SuchergebnisEmptyStateComponent {}
